module.exports = __webpack_public_path__ + "static/card-basketball-7f2c84ecf6d562fb8d97a14ce68948bf.webp";